import { render, staticRenderFns } from "./inbound-voicemail-icon.vue?vue&type=template&id=5d6436af"
import script from "./inbound-voicemail-icon.vue?vue&type=script&lang=js"
export * from "./inbound-voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6436af')) {
      api.createRecord('5d6436af', component.options)
    } else {
      api.reload('5d6436af', component.options)
    }
    module.hot.accept("./inbound-voicemail-icon.vue?vue&type=template&id=5d6436af", function () {
      api.rerender('5d6436af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-voicemail-icon.vue"
export default component.exports